import React from 'react';

/**
 * DashboardHealthScore — compact badge showing overall business health.
 *
 * Props:
 *   score: 0-100
 *   status: "good" | "warning" | "critical"
 *   loading: bool
 */

const STATUS_META = {
  good:     { color: '#10B981', bg: '#ECFDF5', label: 'Running smoothly', icon: '✅' },
  warning:  { color: '#F59E0B', bg: '#FFFBEB', label: 'Needs attention',  icon: '⚠️' },
  critical: { color: '#EF4444', bg: '#FEF2F2', label: 'Action required',  icon: '🔴' },
};

const DashboardHealthScore = ({ score, status = 'good', loading }) => {
  const meta = STATUS_META[status] || STATUS_META.good;

  if (loading) {
    return <div className="skeleton" style={{ height: 56, borderRadius: 12, width: 240 }} />;
  }

  return (
    <div className="health-score-card" style={{ background: meta.bg, borderColor: meta.color }}>
      <span className="health-score-card__icon">{meta.icon}</span>
      <div className="health-score-card__body">
        <span className="health-score-card__label">Store Status</span>
        <div className="health-score-card__row">
          <span className="health-score-card__score" style={{ color: meta.color }}>
            {score}/100
          </span>
          <span className="health-score-card__status" style={{ color: meta.color }}>
            {meta.label}
          </span>
        </div>
      </div>

      {/* Progress bar */}
      <div className="health-score-bar__track">
        <div
          className="health-score-bar__fill"
          style={{ width: `${score}%`, background: meta.color }}
        />
      </div>
    </div>
  );
};

export default DashboardHealthScore;
